import "@polymer/polymer/lib/elements/dom-module";
import { CSSResult } from "lit";
import { tauiStyle } from "../resources/styles";

const documentContainer = document.createElement("template");
documentContainer.setAttribute("style", "display: none;");

documentContainer.innerHTML = `<dom-module id="taui-style">
  <template>
    <style>
    ${(tauiStyle as CSSResult).cssText}
    </style>
  </template>
</dom-module>`;

document.head.appendChild(documentContainer.content);
